jQuery(document).ready(function($) {
    loadAllScreenButtons($);
});

function loadAllScreenButtons($) {
    let actions = ['add', 'shout', 'message', 'truncate', 'migrate', 'invoice'];

    actions.forEach(function(action_name) {
        const sel = $('body').find('[data-'+action_name+'-button-action]');
        if(sel.length > 0) {
            sel.initScreenButton(action_name);
        }
    });

    const sel = $('body').find('[data-selection-button-actions]');
    if(sel.length > 0) {
        actions = sel.attr('data-selection-button-actions').split(',');
        actions.forEach(function(item) {
            const p = item.split('=');
            const type = p[0];
            const action = p[1];
            sel.initScreenButton(type,action, true);
        });
    }
}

(function ( $ ) {
    $.fn.initScreenButton = function(type, action, onselection) {
        var elm = $(this);
        if(action == undefined) {
            action = elm.attr('data-'+type+'-button-action');
        }
        if(action == undefined) {
            console.log("Cannot init start button, because there is no action for it");
        }
        if(onselection == undefined) {
            onselection = false;
        }

        var maxZ = Math.max.apply(null,
            $.map($('.reveal'), function(e,n) {
                if ($(e).css('position') != 'static')
                    return parseInt($(e).css('z-index')) || 1;
        }));

        var over_wrapper = $('body').find('.screen-buttons-wrapper .screen-buttons-container');
        if(over_wrapper.length == 0) {
            $('body').append('<div class="screen-buttons-wrapper"><div class="screen-buttons-container"></div></div>');
            over_wrapper = $('body').find('.screen-buttons-wrapper:first  .screen-buttons-container');
        }

        var w = over_wrapper.find('.'+type+'-button-wrapper');
        if(w.length == 0) {
            over_wrapper.append('<div class="screen-button-wrapper '+type+'-button-wrapper"><a href="#" onclick="return '+action+';" class="'+type+'-button"></a></div>');
            w = over_wrapper.find('.'+type+'-button-wrapper');
        } else {
            w.find('a').attr('onclick', 'return '+action+';');
        }
        w.css('z-index',maxZ);

        if(onselection === true) {
            w.addClass('show-on-selection').addClass('hidden');
            w.css('z-index', maxZ-1);

            over_wrapper.unbind('showScreenSelectionButtons').bind('showScreenSelectionButtons', function() {
                over_wrapper.find('.show-on-selection').removeClass('hidden');
            });
            over_wrapper.unbind('hideScreenSelectionButtons').bind('hideScreenSelectionButtons', function() {
                over_wrapper.find('.show-on-selection').addClass('hidden');
            });
        }

        return this;
    };

}( jQuery ));
